import { getAuthSession, refresh } from "@benefit-systems/webview/plugins/auth";

import type { INativeToken, IStoredToken } from "web/types/Token";

import persistNativeToken from "./persistNativeToken";

let mobileTokenPromise: Promise<INativeToken | null> | null = null;

const getTokenNative = async (
  forceRefresh = false
): Promise<IStoredToken | null> => {
  try {
    const response = await (mobileTokenPromise ??= forceRefresh
      ? refresh()
      : getAuthSession());

    return response ? persistNativeToken(response) : null;
  } finally {
    mobileTokenPromise = null;
  }
};

export default getTokenNative;
